import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export const PostJob = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "", company: "", location: "Remote", employment_type: "Full-time",
    salary_range: "", description: "", required_skills: "", nice_to_have: "", min_experience_years: 0,
  });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/jobs", {
        ...form,
        min_experience_years: Number(form.min_experience_years) || 0,
        required_skills: form.required_skills.split(",").map((s) => s.trim()).filter(Boolean),
        nice_to_have: form.nice_to_have.split(",").map((s) => s.trim()).filter(Boolean),
      });
      toast.success("Job posted");
      navigate(`/recruiter/jobs/${data.job_id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to post");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <div className="mono-label">new opening</div>
      <h1 className="font-display text-3xl font-semibold tracking-tight mt-2">Post a job</h1>

      <form onSubmit={submit} className="mt-8 border border-white/10 bg-[#111827] rounded-xl p-6 space-y-5">
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Job title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testId="post-title" required />
          <Field label="Company" value={form.company} onChange={(v) => setForm({ ...form, company: v })} testId="post-company" required />
          <Field label="Location" value={form.location} onChange={(v) => setForm({ ...form, location: v })} testId="post-location" />
          <Field label="Employment type" value={form.employment_type} onChange={(v) => setForm({ ...form, employment_type: v })} testId="post-type" />
          <Field label="Salary range" value={form.salary_range} onChange={(v) => setForm({ ...form, salary_range: v })} testId="post-salary" />
          <Field label="Min. years experience" type="number" value={form.min_experience_years} onChange={(v) => setForm({ ...form, min_experience_years: v })} testId="post-min-years" />
        </div>

        <div className="space-y-2">
          <Label className="text-slate-300">Description</Label>
          <Textarea rows={8} required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
                    data-testid="post-desc" className="bg-[#0B0F19] border-white/10" />
        </div>
        <Field label="Required skills (comma separated)" value={form.required_skills} onChange={(v) => setForm({ ...form, required_skills: v })} testId="post-req-skills" />
        <Field label="Nice to have (comma separated)" value={form.nice_to_have} onChange={(v) => setForm({ ...form, nice_to_have: v })} testId="post-nice" />

        <div className="flex justify-end">
          <Button type="submit" disabled={busy} data-testid="post-submit" className="bg-[#3B82F6] hover:bg-[#2563EB] text-white rounded-full px-6">
            {busy ? "Posting…" : "Post job"}
          </Button>
        </div>
      </form>
    </div>
  );
};

const Field = ({ label, value, onChange, testId, type = "text", required }) => (
  <div className="space-y-2">
    <Label className="text-slate-300">{label}</Label>
    <Input type={type} required={required} value={value} onChange={(e) => onChange(e.target.value)}
           data-testid={testId} className="bg-[#0B0F19] border-white/10" />
  </div>
);
